import Box from '@mui/material/Box';
import { DataPartnerFeesAlert } from '@openx/components-core/lib/Alert/DataPartnerFeesAlert.tsx';
import { useResourceInfoContext } from '@openx/components-core/lib/Form/context/ResourceInfoContext.tsx';
import type { ContextualPricingApi } from '@openx/types/targeting/contextualPricing.ts';
import { hasContextualFees } from '../utils/contextualPricing.ts';

type ContextualSegmentsFeesAlertProps = {
  contextualPricing?: ContextualPricingApi | null;
};

/** Warns that the attached contextual segments bring fees for data partners. Shown only when there are fees to pay. */
export const ContextualSegmentsFeesAlert = ({ contextualPricing }: ContextualSegmentsFeesAlertProps) => {
  const { name: resourceName } = useResourceInfoContext();

  if (!resourceName || !hasContextualFees(contextualPricing)) {
    return null;
  }

  // The fees section is part of the deal form only, so the package form gets the text without the button.
  const isPackageContext = resourceName === 'package';

  return (
    <DataPartnerFeesAlert
      data-test="contextual-fees-warning"
      actionLabel={isPackageContext ? undefined : 'go to Data Partner Fees'}
      message={
        <>
          External Contextual Segments attached,{' '}
          <Box component="span" sx={{ fontWeight: 'fontWeightBold' }}>
            additional fees apply for enabled Data Partners.
          </Box>{' '}
          {isPackageContext
            ? 'Full details available during deal creation in Curated Deal Fees for Enabled Data Partners section.'
            : 'Full details in Curated Deal Fees for Enabled Data Partners section above.'}
        </>
      }
    />
  );
};
